<div class="my-orders-wrapper">
  <div class="detail-header">
    <h3>My Orders — Outbound Status</h3>
    <button class="btn-bg-red" (click)="returnToList()">← Return</button>
  </div>

  <div class="filter-row">
    <label>
      <input type="checkbox" [(ngModel)]="ShowUnsentOnly" />
      Show only orders not yet sent to Outbound
    </label>
  </div>

  @if (Loading) {
  <div class="loading">Loading...</div>
  } @else if (Orders.length === 0) {
  <p class="muted">No orders found linked to your trader account. If this seems wrong, your trader profile may not be linked yet — contact an admin.</p>
  } @else {
  <table class="doc-table">
    <thead>
      <tr><th>Order #</th><th>Customer</th><th>Status</th><th>Pickup Date</th><th>Sent to Outbound</th></tr>
    </thead>
    <tbody>
      @for (order of filteredOrders; track order.OrderID) {
      <tr [class.reconciliation-missing]="order.NotYetSentToOutbound">
        <td>{{ order.OrderID }}</td>
        <td>{{ order.Customer }}</td>
        <td>{{ order.StatusName }}</td>
        <td>{{ order.PickupDate | date:'MM-dd-yyyy' }}</td>
        <td>{{ order.SentToOutbound ? (order.SentToOutbound | date:'MM-dd-yyyy') : '—' }}</td>
      </tr>
      }
    </tbody>
  </table>
  }
</div>
